"use strict";

import _Object$getPrototypeOf from "babel-runtime/core-js/object/get-prototype-of";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import Item from './Item';

var Person = function (_Item) {
    _inherits(Person, _Item);

    function Person() {
        _classCallCheck(this, Person);

        return _possibleConstructorReturn(this, (Person.__proto__ || _Object$getPrototypeOf(Person)).apply(this, arguments));
    }

    return Person;
}(Item);

export default Person;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Items/Person.js
// module id = 111
// module chunks = 0